// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1VBlr","errors":"Errors_errors__33Y6l"};